import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default function useViewShow() {
  const [showCashier, setShowCashier] = useState(false);
  const [showElevator, setShowElevator] = useState(false);
  const [showIntercom, setShowIntercom] = useState(false);
  const [hotelId, setHotelId] = useState<number | null>(null);
  const [idInRoom, setIdInRoom] = useState<number | null>(null);

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Estate.EstateHotelCashierShow,
      async (
        state: typeof RegionShared.Cef.Requests.EstateHotelCashierShowRequest,
      ): Promise<void> => {
        setShowCashier(true);
        setHotelId(state?.estateHotelId ?? null);
      },
    );

    rpc.register(RegionShared.Cef.Events.Estate.EstateHotelCashierHide, async (): Promise<void> => {
      setShowCashier(false);
      setHotelId(null);
    });

    rpc.register(
      RegionShared.Cef.Events.Estate.EstateHotelElevatorShow,
      async (
        state: typeof RegionShared.Cef.Requests.EstateHotelElevatorShowRequest,
      ): Promise<void> => {
        setShowElevator(true);
        setHotelId(state?.estateHotelId ?? null);
      },
    );

    rpc.register(
      RegionShared.Cef.Events.Estate.EstateHotelElevatorHide,
      async (): Promise<void> => {
        setShowElevator(false);
        setHotelId(null);
      },
    );

    rpc.register(
      RegionShared.Cef.Events.Estate.EstateHotelRoomIntercomShow,
      async (
        state: typeof RegionShared.Cef.Requests.EstateHotelRoomIntercomShowRequest,
      ): Promise<void> => {
        setShowIntercom(true);
        setIdInRoom(state?.estateId ?? null);
      },
    );

    rpc.register(
      RegionShared.Cef.Events.Estate.EstateHotelRoomIntercomHide,
      async (): Promise<void> => {
        setShowIntercom(false);
        setIdInRoom(null);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateHotelCashierShow);
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateHotelCashierHide);
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateHotelElevatorShow);
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateHotelElevatorHide);
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateHotelRoomIntercomShow);
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateHotelRoomIntercomHide);
    };
  }, []);

  return {
    showCashier,
    showElevator,
    showIntercom,
    hotelId,
    idInRoom,
  };
}
